<template>
  <el-button @click="hx" :class="{'setting':true,'pulse-shrink':t}">系统设置</el-button>
</template>

<script>
  export default {
    name: "LoginSetting",
    data() {
      return {
        t: false,
        text: "系统设置",
        time: 5000
      }
    },
    mounted() {
      obj_login.registerJavaScriptCallback("setPulseShrink", () => {
        this.t = true;
        setTimeout(() => {
          this.t = false
        }, time)
      });
      obj_login.registerJavaScriptCallback("setText", (value) => {
        this.text = value
      });
      obj_login.registerJavaScriptCallback("setTime", (value) => {
        this.time = value
      });
    },
    methods: {
      hx() {
        this.t = false;
        obj_login.settingBtnCLick();
      }
    }
  }
</script>

<style scoped>
  @import "../components/hover.css";

  .hover {
    border: 1px white solid;
  }

  .setting {
    height: 100%;
    width: 100%;
    font-size: 14pt;
    background-color: #34458c;
    color: white;
  }
</style>
